var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBackIcon = function SvgBackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ACB3BE",
    fillRule: "evenodd",
    d: "M6.71 11.704a.999.999 0 0 0 0-1.418l-3.3-3.288H15A1 1 0 1 0 15 5H3.41l3.3-3.287A1.003 1.003 0 1 0 5.29.293l-5 4.997a1 1 0 0 0-.21.33.939.939 0 0 0 0 .759.999.999 0 0 0 .21.33l5 4.995a1 1 0 0 0 1.42 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgBackIcon;